import { bl_fi_mst_entity_conglomerate_link_RowClass } from '../../../dbschema/bl_fi_mst_entity_conglomerate_link.model';
import { BaseContainerModel } from '../../base-container.model';

export class EntityConglomerateLinkContainer extends BaseContainerModel{
    bl_fi_mst_entity_conglomerate_link: bl_fi_mst_entity_conglomerate_link_RowClass = new bl_fi_mst_entity_conglomerate_link_RowClass();
}